import Helmet from 'react-helmet'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import Page from 'rui/widgets/Page'
import Panel from 'components/layout/Panel'
import styled from 'styled-components/macro'
import { body1 } from 'styles/mixins/textstyles'
import { Icon } from 'roadie-ui'
import { useLocalization, LocalizedText } from 'localization'
import { FeatureFlag } from 'Optimizely'

const EditLink = styled(Link)`
  ${(props) => body1(props.theme.colors.black, 'medium')}
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.6rem;
  text-align: left;

  &:not(:last-child) {
    border-bottom: 1px solid ${(props) => props.theme.colors.greyLighter};
  }
`

const DeleteLink = styled(EditLink)`
  color: ${(props) => props.theme.colors.errorBase};
`

const Arrow = styled(Icon.ChevronRight).attrs({ $color: 'neutral-light' })`
  width: 1.4rem;
  height: 1.4rem;
`

const Gap = styled.div`
  height: calc(100vh - 52rem);
`

const SmallGap = styled.div`
  height: 3rem;
`

const EditAccountNavPage = () => {
  const { t } = useLocalization()
  const seattleDriver = useSelector((state) => state.seattleDriver)

  const languagePreferenceLink = (
    <EditLink to="/webview/account/language-preference">
      <span>{t('dweb_common_language_preference')}</span> <Arrow />
    </EditLink>
  )

  return (
    <Page>
      <Helmet>
        <title>{t('dweb_edit_account_nav_edit_account')}</title>
      </Helmet>
      <Panel noPadding>
        {/* TODO: Remove /webview from these routes and implement function to make /webview stay within the URL when switching pages */}
        <EditLink to="/webview/account/bio">
          <span>
            <LocalizedText translationKey="dweb_layout_drive_sidebar_photo_bio" />
          </span>{' '}
          <Arrow />
        </EditLink>
        <EditLink to="/webview/account/basic-info">
          <span>
            <LocalizedText translationKey="dweb_layout_drive_sidebar_basic_info" />
          </span>{' '}
          <Arrow />
        </EditLink>
        <EditLink to="/webview/account/driving-info">
          <span>
            <LocalizedText translationKey="dweb_common_driving_info" />
          </span>{' '}
          <Arrow />
        </EditLink>
        <EditLink to="/webview/account/bank-info">
          <span>
            <LocalizedText translationKey="dweb_layout_drive_sidebar_payment_info" />
          </span>{' '}
          <Arrow />
        </EditLink>
        <EditLink to="/webview/account/contact-info">
          <span>
            <LocalizedText translationKey="dweb_layout_drive_sidebar_email_phone" />
          </span>{' '}
          <Arrow />
        </EditLink>
        <EditLink to="/webview/account/password">
          <span>
            <LocalizedText translationKey="dweb_common_password" />
          </span>{' '}
          <Arrow />
        </EditLink>
      </Panel>
      <SmallGap />
      <Panel noPadding>
        {seattleDriver ? (
          languagePreferenceLink
        ) : (
          <FeatureFlag feature="drive_language_preference_access">{languagePreferenceLink}</FeatureFlag>
        )}
        <EditLink to="/webview/account/privacy-settings">
          <span>
            <LocalizedText translationKey="dweb_edit_account_nav_privacy_setting" />
          </span>{' '}
          <Arrow />
        </EditLink>
      </Panel>
      <Gap />
      <Panel noPadding>
        <DeleteLink to="/webview/account/delete">
          <span>
            <LocalizedText translationKey="dweb_edit_account_nav_delete_account" />
          </span>{' '}
          <Arrow />
        </DeleteLink>
      </Panel>
    </Page>
  )
}

export default EditAccountNavPage
